// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "static/js/" + ({"270":"QR","780":"AppRouter"}[chunkId] || chunkId) + "." + {"270":"48d26edc","287":"df340e7f","687":"5be3c1fe","723":"2d2ed94f","780":"bdd3e0f1","787":"8481030a","800":"bc70eeb4"}[chunkId] + ".chunk.js";
};